import { HTMLInputTypeAttribute } from "react";

import "../Input.css";

type Props = Readonly<{
  "data-test-id"?: string;
  label: string;
  onChange: (val: string) => void;
  placeholder?: string;
  value?: string;
  type?: HTMLInputTypeAttribute;
  disabled?: boolean;
  labelSpan?: number;
  min?: number;
  max?: number;
  className?: string;
}>;

export default function TextInput({
  label,
  value,
  onChange,
  placeholder = "",
  "data-test-id": dataTestId,
  type = "text",
  disabled = false,
  labelSpan = 2,
  min,
  max,
  className,
}: Props): JSX.Element {
  return (
    <div className="Input__wrapper">
      <label className="Input__label">{label}</label>
      <input
        type={type}
        className={`Input__input ${className}`}
        style={{ flex: `${labelSpan} 1` }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        min={min}
        max={max}
        data-test-id={dataTestId}
        disabled={disabled}
      />
    </div>
  );
}
